module.exports = __webpack_public_path__ + "img/module_cassa.4a2d4f69.jpg";